let date = new Date();
let day = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
let currHrs = date.getHours();
let currMins = date.getMinutes();
let arrOpenDay = [];
let arrOpenDays = [];
let currDay = day[date.getDay()];
let openDays = document.querySelectorAll('.open_day');
let openTime = document.querySelector('.open_start_time');
let endTime = document.querySelector('.open_end_time');
for(var i=0;i<openDays.length;i++) {
    arrOpenDay.push(openDays[i].value);
}
for(var j=0;j<arrOpenDay.length;j++) {
    arrOpenDays.push( day[ arrOpenDay[j] ] );
}
// console.log(currDay, openTime.value, endTime.value, arrOpenDays);

if( arrOpenDays.indexOf( currDay ) > -1 ) {
    if( currHrs >= openTime.value.split('.')[0] && currHrs < endTime.value.split('.')[0]  ) {
        document.querySelector('.js-msg-default').style.display = 'inline-flex';
        console.log('Open today');
    } else if( currHrs == endTime.value.split('.')[0] && currMins < endTime.value.split('.')[1] ) {
        document.querySelector('.js-msg-default').style.display = 'inline-flex';
        console.log('Open today');
    } else if( currDay == day[date.getDay()] ) {
        document.querySelector('.js-msg-2').style.display = 'inline-flex';
        console.log('Open on monday');
    } else {
        document.querySelector('.js-msg-1').style.display = 'inline-flex';
        console.log('Open tomorrow');
    }
} else {
    document.querySelector('.js-msg-2').style.display = 'inline-flex';
    console.log('Open on monday');
}

function moveOpenTime() {
    const openTime = document.querySelector('.open-time');
    const drawer = document.querySelector('.open-time-drawer');
    const header = document.querySelector('.open-time-header');

    if (!openTime || !drawer || !header) return;

    if (window.innerWidth <= 768) {
        if (!drawer.contains(openTime)) {
        drawer.appendChild(openTime);
        }
    } else {
        if (!header.contains(openTime)) {
        header.appendChild(openTime);
        }
    }
}

// Run on load
window.addEventListener('DOMContentLoaded', moveOpenTime);
// Run on resize
window.addEventListener('resize', moveOpenTime);